import { MetricGroup } from 'types'

export function modifyMetricsInGroup(metricGroups: MetricGroup[]): MetricGroup[] {
  // const RnDTargets = ['AI Repository Publications', 'AI Repository Citations', 'AI Patent Applications']
  // const EcoTargets = ['AI Hiring Index', 'AI Talent Concentration']

  return metricGroups.map((group) => {
    // if (group.metricGroupNameDatakey === 'research') {
    //   // Create new objects for metricList absolute and perCapita to avoid mutation
    //   const newMetricList = {
    //     ...group.metricList,
    //     absolute:
    //       group.metricList?.absolute.filter((item) => !RnDTargets.includes(Object.values(item)[0] as string)) || [],
    //     perCapita:
    //       group.metricList?.perCapita.filter((item) => !RnDTargets.includes(Object.values(item)[0] as string)) || [],
    //   }
    //   // Create a new array for metrics to avoid direct mutation
    //   const newMetrics = group.metrics.filter(
    //     (metric) => !RnDTargets.some((target) => metric.metricName.includes(target)),
    //   )
    //   return {
    //     ...group,
    //     metricList: newMetricList,
    //     metrics: newMetrics,
    //   }
    // }
    // if (group.metricGroupNameDatakey === 'economy') {
    //   // Create new objects for metricList absolute and perCapita to avoid mutation
    //   const newMetricList = {
    //     ...group.metricList,
    //     absolute:
    //       group.metricList?.absolute.filter((item) => !EcoTargets.includes(Object.values(item)[0] as string)) || [],
    //     perCapita:
    //       group.metricList?.perCapita.filter((item) => !EcoTargets.includes(Object.values(item)[0] as string)) || [],
    //   }
    //   // Create a new array for metrics to avoid direct mutation
    //   const newMetrics = group.metrics.filter(
    //     (metric) => !EcoTargets.some((target) => metric.metricName.includes(target)),
    //   )
    //   return {
    //     ...group,
    //     metricList: newMetricList,
    //     metrics: newMetrics,
    //   }
    // }
    return group
  })
}
